const STRIPE_PUBLISHABLE =
  process.env.NODE_ENV === 'production'
    ? 'pk_live_1fPRsiwrJ597GHmZrlRsM55J'
    : 'pk_test_DecFC8P8DTofO4WbNJO1eKzw';

export default STRIPE_PUBLISHABLE;



// WEBPACK FOOTER //
// ./src/constants/stripe.js